import { Injectable } from '@angular/core';
import { ApiClientService } from '../api-client.service';
import { Observable } from 'rxjs/Observable';
import { ApiResponseList } from '../../types/api-response/helpers';
import { IVendor } from '../../types/api-response/building/vendor';
import { IVendorCategory } from '../../types/api-response/building/vendor-category';

@Injectable()
export class VendorApiService {

    constructor(private api: ApiClientService) {}

    /**
     * Returns Pass On Log settings details
     */
    getVendors(): Observable<ApiResponseList<IVendor>> {
        return this.api.getJson('domainVendors', '/v1/vendors');
    }

    /**
     * Returns Pass On Log settings details
     */
    getVendorsShort(params): Observable<ApiResponseList<IVendor>> {
        return this.api.getJson('domainVendors', '/v1/vendors/short' + ApiClientService.serialize(params));
    }

    /**
     * Returns vendor categories
     * @param params
     */
    getVendorCategories(params): Observable<ApiResponseList<IVendorCategory>> {
        return this.api.getJson('domainVendors', '/v1/admin/categories' + ApiClientService.serialize(params));
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/api/vendor-api.service.ts